

import router from "@/router";




import optics from '@/container/optics'
import vision_test from '@/components/optics/vision_test'


router.addRoute({
    name: 'homepage' ,
    path: '/', 
    component: optics ,
    meta: {
        requiresAuth: true,
        //title: 'message.dashboard1',
        //breadcrumb: 'message.dashboardDashboard1'
    },
    children: [
        {
            name: 'vision_test',
            path: '/vision_test',
            component: vision_test,
            meta: {
                requiresAuth: true,
                title: 'message.vision_test',
                //breadcrumb: 'message.dashboardDashboard1'
            }
        }
    ]
})
const Login = () => import('Views/session/Login')


router.addRoute({ name: 'login' ,path: '/session/Login/', component: Login })



//$t('message.homepage')

export default router